import { useState,useEffect } from "react";
import useFetch from "../../../hooks/useFetch";
import Spinner from "../../../components/Spinner";
import ListServicesCounter from "./list_services_counter";
import { Link } from "react-router-dom";

const ListChart = () => {

    const {
        data: counter_per_service,
        isLoading,
        errorMessage,
    } = useFetch(`${process.env.REACT_APP_API_URL}/socialservice_counter/`);


    return (
        <>
            <div className="col-md-6 col-lg-8 mb-4 mb-md-0">
                <div className="card">
                    <div className="table-responsive text-nowrap">
                        <table className="table text-nowrap">
                            <thead>
                                <tr>
                                    <th>SERVICE TYPE</th>
                                    <th>RELEASED</th>
                                    <th>PENDING</th>
                                    <th>TOTAL</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-border-bottom-0">

                                {isLoading && <Spinner />}
                                {errorMessage && <div>{errorMessage}</div>}
                                 {counter_per_service && counter_per_service.map((service, index) => (
                                     <tr key={index}>
                                         <td>
                                             <div className="d-flex align-items-center">
                                            
                                                <img src="../../iusevolutione/assets/svg/icons/shopping-bag-icon.svg" width={32} height={32} alt="Service Type"  className="me-2"  />

                                                 <div className="d-flex flex-column">
                                                     <span className="fw-medium lh-1">{service.ss_type.toUpperCase()}</span>
                                                     <small className="text-muted">Service</small>
                                                 </div>
                                             </div>
                                         </td>
                                         <td>
                                             {service.approved_count}
                                         </td>
                                         <td>
                                             <div className="text-muted lh-1"><span className="text-primary fw-medium">{service.for_approval_count}</span></div>
                                             <small className="text-muted d-none">Partially Paid</small>
                                         </td>
                                         <td><span className="badge bg-label-primary">{service.count}</span></td>
                                         <td>
                                             <div className="dropdown">
                                                 <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                     <i className="bx bx-dots-vertical-rounded" />
                                                 </button>
                                                 <div className="dropdown-menu">
                                                     <Link to={`/ss/${service.ss_type}`} className="dropdown-item" href="javascript:void(0);"><i className="bx bx-edit-alt me-1" /> View Information</Link>
                                                 </div>
                                             </div>
                                         </td>
                                     </tr>
                                 ))}
                           

                             
  
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </>
    );
}

export default ListChart;